import React from "react"
import PropTypes from 'prop-types'
import { Navigate, useLocation } from "react-router-dom"
import { isTokenExpired } from "pages/Utility/token"

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => {
  const location = useLocation()

  if (isAuthProtected) {
    const hasUser = !!localStorage.getItem("authUser")
    const expired = isTokenExpired()

    if (!hasUser || expired) {
      if (expired) {
        localStorage.removeItem("veeperAuthToken")
        localStorage.removeItem("authUser")
      }
      return <Navigate to="/login" state={{ from: location }} replace />
    }
  }

  return (
    <Layout>
      <Component {...rest} />
    </Layout>
  )
}

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any
}

export default AppRoute
